export const getAuthToken = () => {
  return localStorage.getItem('token');
};

export const setAuthToken = (token) => {
  if (token) localStorage.setItem('token', token); else localStorage.removeItem('token');
};